import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import * as Styles from './Sidebar.styles';
import { SidebarOptionType } from '../../types/routes';

export type CustomSidebarOptionType = SidebarOptionType & {
  isSelected: boolean;
};

type SidebarProps = {
  options: CustomSidebarOptionType[];
  toggleMenu: () => void;
  isOpen: boolean;
};

const Sidebar = function ({ options, toggleMenu, isOpen }: SidebarProps): JSX.Element {
  if (!options.length) {
    return <div />;
  }

  return (
    <Styles.Sidebar isOpen={isOpen} data-testid="sidebar">
      <nav data-testid={`sidebar-${isOpen ? 'opened' : 'closed'}`}>
        <ul>
          {options.map((option) => {
            const Icon = option.icon;
            return (
              <li data-testid="sidebar-item" key={option.label}>
                <Styles.SidebarLink
                  data-testid={`${option.isSelected ? 'sidebar-item-selected' : ''}`}
                  $isSelected={option.isSelected}
                  className="flex align-center"
                  to={option.path}
                >
                  <Icon />
                  <p>{option.label}</p>
                </Styles.SidebarLink>
              </li>
            );
          })}

          <li>
            <Styles.SidebarExpandButton
              isOpen={isOpen}
              aria-label={isOpen ? 'Close sidebar' : 'Open sidebar'}
              data-testid="toggle-sidebar"
              onClick={toggleMenu}
              className="flex align-center"
            >
              <ChevronRightIcon />
            </Styles.SidebarExpandButton>
          </li>
        </ul>
      </nav>
    </Styles.Sidebar>
  );
};

export default Sidebar;
